import axios from 'axios'
import auth0 from 'auth0-js'
import store from '../store'

import {
    AUTH_AUDIENCE,
    AUTH_DOMAIN,
    AUTH_CLIENT_ID
} from '../utils/constants'

class AuthService {
    start() {
        console.log('Constructing auth service....')
        this.auth = new auth0.WebAuth({
            clientID: AUTH_CLIENT_ID,
            audience: AUTH_AUDIENCE,
            domain: AUTH_DOMAIN,
            responseType: 'token id_token',
            scope: 'openid profile email'
        })
        console.log('..done')
    }

    login() {
        this.auth.authorize({
            redirectUri: `${window.location.origin}/authcallback`
        })
    }

    logout() {
        console.log("SERVICE LOGOUT HIT")
        store.dispatch('logout')
        this.auth.logout({
            returnTo: `${window.location.origin}/logout`
        })
    }

    refreshSession() {
        return new Promise((resolve, reject) => {
            console.log('Refreshing session')
            this.auth.checkSession({
                redirectUri: `${window.location.origin}/authcallback`
            }, (error, authResult) => {
                console.log('Refresh session came back')
                if (error) {
                    console.error('Error refreshing token', error)
                    reject(error)
                }
                else {
                    store.dispatch('setUserIdToken', authResult.idToken)
                    store.dispatch('setUserAccessToken', authResult.accessToken)
                    // axios.defaults.headers.common['Authorization'] = `Bearer ${authResult.accessToken}`
                    resolve(authResult)
                }
            })
        })
    }

    // Get and store access_token in local storage
    setAccessToken() {
        let accessToken = this._getParameterByName('access_token')
        console.log('------------------------------')
        console.log('Access token:')
        console.log(accessToken)
        console.log('------------------------------')
        if (accessToken != null) {
            store.dispatch('setUserAccessToken', accessToken)
            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
        }
    }

    setIdToken() {
        let idToken = this._getParameterByName('id_token')
        if (idToken != null) {
            store.dispatch('setUserIdToken', idToken)
        }
    }

    // Helper function that will allow us to extract the access_token and id_token
    _getParameterByName(name) {
        let match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash)
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '))
    }
}

export default AuthService